<div class="header">
  <h2>Campaigns</h2>
</div>
<mat-card>
  <button
    mat-flat-button
    color="primary"
    routerLinkActive="router-link-active"
    [routerLink]="['/notifications', 'events', 'create-event']"
  >
    <mat-icon>add</mat-icon>
    Create Campaign
  </button>
  <div class="table-container mat-elevation-z0">
    <table
      mat-table
      [dataSource]="eventsList?.results"
      matTableResponsive
      class="full-width"
    >
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef class="small-cell">No.</th>
        <td mat-cell *matCellDef="let i = index" class="small-cell">
          {{ i + 1 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let record">
          {{ record.title || "-" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>Subject</th>
        <td mat-cell *matCellDef="let record">
          {{ record.subject || "-" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let record">
          {{ record.is_sent ? "Sent" : "Draft" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let record">
          {{ record.notification_event_type_display || "-" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="group">
        <th mat-header-cell *matHeaderCellDef>Group</th>
        <td mat-cell *matCellDef="let record">
          {{ record.notification_group_detail?.name || "-" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let record">
          <button
            mat-stroked-button
            color="primary"
            class="inline-item"
            (click)="getEventDetails(record.id)"
          >
            Detail
          </button>
          <button
            *ngIf="!record.is_sent"
            mat-stroked-button
            color="primary"
            class="inline-item"
            (click)="broadCastMessage(record.id)"
          >
            Broadcast
          </button>
          <button
            *ngIf="record.is_sent"
            mat-stroked-button
            color="primary"
            class="inline-item"
            (click)="resendCampaign(record.id)"
          >
            Resend
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="eventsList?.count"
      (page)="onPaginationChange($event)"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
    ></mat-paginator>
  </div>
</mat-card>

<ng-template #broadCast>
  <mat-dialog-content>
    Are you sure want to broadcast message ?
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>yes</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #detail>
  <div class="message-info" *ngIf="event">
    <h3>Preview</h3>
    <div class="message-wrapper">
      <!-- <p class="date">{{event.created_time | date:'mm'}}</p> -->
      <p class="subject">{{ event.subject }}</p>
      <!-- <p class="title">{{event.notification_event_detail?.title}}</p> -->
      <p
        [innerHtml]="
          event.content || event?.template_detail?.content | safeHtml
        "
      ></p>
    </div>
    <div
      class="delivery-report"
      *ngIf="event.notification_groups_detail.length"
    >
      <h3>Groups</h3>
      <ul>
        <li *ngFor="let group of event.notification_groups_detail">
          {{ group.name }}
        </li>
      </ul>
    </div>
    <div class="delivery-report" *ngIf="event.contact_groups_detail.length">
      <h3>Groups</h3>
      <ul>
        <li *ngFor="let contactGroup of event.contact_groups_detail">
          {{ contactGroup.name }}
        </li>
      </ul>
    </div>
    <div class="delivery-report" *ngIf="event.is_sent">
      <h3>Statistics</h3>
      <p>Sent Time: {{ event.sent_time | date : "MM/dd/yyyy HH:mm:ss" }}</p>
      <p>Sent: {{ event.sent_status_count | number }}</p>
      <p>Pending: {{ event.pending_status_count | number }}</p>
      <p>Failed: {{ event.failed_status_count | number }}</p>
      <p>Delivery: {{ event.delivery_status_count | number }}</p>
    </div>
    <!-- <p class="title">{{event.notification_event_detail?.template_detail?.title}}</p> -->
    <!-- <p [innerHtml]="event.notification_event_detail?.template_detail?.content"></p> -->
  </div>
</ng-template>

<ng-template #broadcastNewEvent>
  <mat-dialog-content>
    Do you want to broadcast this campaign now?
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Maybe later</button>
    <button mat-button (click)="broadCastMessage(newEvent)">Yes</button>
  </mat-dialog-actions>
</ng-template>
